import produce from 'immer';
import {
  TRANSLATION_ADOPT,
  TRANSLATION_ADOPT_FAILED,
  TRANSLATION_ADOPT_SUCCESS,
  TRANSLATION_CLEAR,
  TRANSLATION_FETCH_CANDIDATE,
  TRANSLATION_FETCH_CANDIDATE_FAILED,
  TRANSLATION_FETCH_CANDIDATE_SUCCESS,
  TRANSLATION_FETCH_OVERVIEW,
  TRANSLATION_FETCH_OVERVIEW_FAILED,
  TRANSLATION_FETCH_OVERVIEW_SUCCESS,
  TRANSLATION_GENERATE,
  TRANSLATION_GENERATE_FAILED,
  TRANSLATION_GENERATE_SUCCESS,
  TRANSLATION_POLL_DELAYED,
  TRANSLATION_RETRY_BATCH,
  TRANSLATION_RETRY_FAILED,
  TRANSLATION_RETRY_JOB,
  TRANSLATION_RETRY_SUCCESS,
  TRANSLATION_START_POLL,
  TRANSLATION_STOP_POLL,
} from 'actions/translationActions';

export const initialState = {
  activePostId: null,
  overview: null,
  loadingOverview: false,
  overviewError: null,
  generationResult: null,
  candidates: {},
  candidateCycles: {},
  candidateErrors: {},
  loadingCandidates: {},
  pending: {},
  error: null,
  errorOperation: null,
  pollStartedAt: null,
  delayed: false,
};

const translationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TRANSLATION_FETCH_OVERVIEW:
        draft.activePostId = action.postId;
        draft.loadingOverview = true;
        draft.overviewError = null;
        break;
      case TRANSLATION_FETCH_OVERVIEW_SUCCESS:
        if (draft.activePostId !== action.postId) break;
        draft.overview = action.overview;
        draft.loadingOverview = false;
        draft.overviewError = null;
        break;
      case TRANSLATION_FETCH_OVERVIEW_FAILED:
        if (draft.activePostId !== action.postId) break;
        draft.loadingOverview = false;
        draft.overviewError = action.error;
        break;
      case TRANSLATION_GENERATE:
        draft.activePostId = action.postId;
        draft.pending.generate = true;
        draft.generationResult = null;
        draft.error = null;
        draft.errorOperation = null;
        break;
      case TRANSLATION_GENERATE_SUCCESS:
        delete draft.pending.generate;
        draft.generationResult = action.result || null;
        draft.error = null;
        draft.errorOperation = null;
        break;
      case TRANSLATION_GENERATE_FAILED:
        delete draft.pending.generate;
        draft.error = action.error;
        draft.errorOperation = {type: 'generate'};
        break;
      case TRANSLATION_FETCH_CANDIDATE:
        draft.loadingCandidates[action.previewKey] = true;
        delete draft.candidateErrors[action.previewKey];
        break;
      case TRANSLATION_FETCH_CANDIDATE_SUCCESS:
        if (
          action.requestCycle !==
          (draft.candidateCycles[action.previewKey] || 0)
        ) break;
        draft.candidates[action.previewKey] = action.candidate;
        delete draft.loadingCandidates[action.previewKey];
        delete draft.candidateErrors[action.previewKey];
        if (
          draft.errorOperation?.type === 'candidate' &&
          draft.errorOperation.resourceId === action.previewKey
        ) {
          draft.error = null;
          draft.errorOperation = null;
        }
        break;
      case TRANSLATION_FETCH_CANDIDATE_FAILED:
        if (
          action.requestCycle !==
          (draft.candidateCycles[action.previewKey] || 0)
        ) break;
        delete draft.loadingCandidates[action.previewKey];
        draft.candidateErrors[action.previewKey] = action.error;
        draft.error = action.error;
        draft.errorOperation = {
          type: 'candidate',
          resourceId: action.previewKey,
        };
        break;
      case TRANSLATION_ADOPT:
        draft.pending[`adopt:${action.previewKey}`] = true;
        draft.error = null;
        draft.errorOperation = null;
        break;
      case TRANSLATION_ADOPT_SUCCESS:
        delete draft.pending[`adopt:${action.previewKey}`];
        draft.candidates[action.previewKey] = {
          ...draft.candidates[action.previewKey],
          ...action.result,
          status: 'ADOPTED',
        };
        draft.error = null;
        draft.errorOperation = null;
        break;
      case TRANSLATION_ADOPT_FAILED:
        delete draft.pending[`adopt:${action.previewKey}`];
        draft.error = action.error;
        draft.errorOperation = {
          type: 'adopt',
          resourceId: action.previewKey,
        };
        break;
      case TRANSLATION_RETRY_BATCH:
      case TRANSLATION_RETRY_JOB:
        draft.pending[`retry:${action.previewKey}`] = true;
        draft.candidateCycles[action.previewKey] =
          (draft.candidateCycles[action.previewKey] || 0) + 1;
        delete draft.candidates[action.previewKey];
        delete draft.candidateErrors[action.previewKey];
        delete draft.loadingCandidates[action.previewKey];
        draft.error = null;
        draft.errorOperation = null;
        break;
      case TRANSLATION_RETRY_SUCCESS:
      case TRANSLATION_RETRY_FAILED:
        delete draft.pending[`retry:${action.resourceId}`];
        if (action.error) {
          draft.error = action.error;
          draft.errorOperation = {
            type: 'retry',
            resourceId: action.resourceId,
          };
        }
        break;
      case TRANSLATION_START_POLL:
        draft.activePostId = action.postId;
        draft.pollStartedAt = Date.now();
        draft.delayed = false;
        break;
      case TRANSLATION_POLL_DELAYED:
        if (draft.activePostId === action.postId) draft.delayed = true;
        break;
      case TRANSLATION_STOP_POLL:
        if (draft.activePostId === action.postId) {
          draft.pollStartedAt = null;
          draft.delayed = false;
        }
        break;
      case TRANSLATION_CLEAR:
        Object.keys(draft).forEach((key) => delete draft[key]);
        Object.assign(draft, initialState);
        break;
      default:
        break;
    }
  });

export default translationReducer;
